export const STATUS = {
  DRAFT: { id: 'DRAFT', name: 'Draf' },
  ACTIVE: { id: 'ACTIVE', name: 'Aktif' },
  EXPIRED: { id: 'EXPIRED', name: 'Kadaluwarsa' },
  INACTIVE: { id: 'INACTIVE', name: 'Non Aktif' },
}

const statusTransitions = {
  Draf: [
    {
      status: STATUS.ACTIVE,
    },
  ],
  Aktif: [
    {
      status: STATUS.INACTIVE,
    },
  ],
  'Non Aktif': [
    {
      status: STATUS.ACTIVE,
    },
  ],

  Kadaluwarsa: [],

  /* SCHEDULED */
  // Dijadwalkan: [
  //   {
  //     status: status.STARTED,
  //   },
  //   {
  //     status: status.CANCELED,
  //     customModalTransition: TransitionToCancelModal,
  //   }
  // ],
}

export default statusTransitions
